import { createContext } from "react";

// Default context value — matches the shape provided by AuthProvider.
// Used when a component reads useAuth() before being mounted under <AuthProvider>.
export const AuthContext = createContext({
  user: null,
  login: () => {},
  logout: async () => {},
  isAuthenticated: false,
  loading: true,
  hasRole: () => false,
  hasPermission: () => false,
});
